import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { sendFrontAction } from '../../services/api';
import CarCard from '../../components/CarCard/CarCard';
import './Catalog.css';

const BODY_TYPES = [
    'Седан', 'Хэтчбек', 'Внедорожник', 'Touring',
    'Coupe', 'Cabrio',
];
const FUEL_TYPES = ['Бензин', 'Дизель', 'Электро', 'Гибрид'];
const DRIVE_TYPES = ['Передний', 'Задний', 'Полный'];

const emptyFilters = {
    model: '',
    priceFrom: '',
    priceTo: '',
    bodyTypes: [],
    fuelTypes: [],
    driveTypes: [],
    specialOffers: false,
    inStockOnly: false,
};

const Catalog = ({ type }) => {
    const [cars, setCars] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState(emptyFilters);
    const [draftFilters, setDraftFilters] = useState(emptyFilters);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const isUsed = type === 'used';

    const loadCars = async () => {
        setLoading(true);
        try {
            const data = await sendFrontAction('catalog', {
                type: type,
                body_type: filters.bodyTypes.join(','),
                model: filters.model,
                price_from: filters.priceFrom,
                price_to: filters.priceTo,
                fuel_type: filters.fuelTypes.join(','),
                drive_type: filters.driveTypes.join(','),
                special_offers: filters.specialOffers,
                in_stock_only: filters.inStockOnly,
            });
            setCars(data);
        } catch (error) {
            console.error("Ошибка загрузки каталога автомобилей:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadCars();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type, filters]);

    useEffect(() => {
        if (isFilterOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => { document.body.style.overflow = ''; };
    }, [isFilterOpen]);

    const openFilters = () => {
        setDraftFilters(filters);
        setIsFilterOpen(true);
    };

    const toggleDraftArrayValue = (key, value) => {
        setDraftFilters(prev => {
            const arr = prev[key];
            return {
                ...prev,
                [key]: arr.includes(value) ? arr.filter(v => v !== value) : [...arr, value],
            };
        });
    };

    const applyFilters = () => {
        setFilters(draftFilters);
        setIsFilterOpen(false);
    };

    const resetFilters = () => {
        setDraftFilters(emptyFilters);
    };

    const activeFilterCount =
        filters.bodyTypes.length +
        filters.fuelTypes.length +
        filters.driveTypes.length +
        (filters.model ? 1 : 0) +
        (filters.priceFrom ? 1 : 0) +
        (filters.priceTo ? 1 : 0) +
        (filters.specialOffers ? 1 : 0) +
        (filters.inStockOnly ? 1 : 0);

    if (loading) return <div className="catalog-loader">Загрузка моделей BMW....</div>;

    return (
        <div className="catalog-container">
            <Link to="/" className="catalog-back-link">‹ Назад на главное меню</Link>
            <h1 className="catalog-main-title">
                {isUsed ? 'BMW с пробегом' : 'Новые BMW в наличии'}
            </h1>

            <div className="catalog-filter-trigger-row">
                <button className="catalog-filter-trigger-btn" onClick={openFilters}>
                    Фильтровать
                    {activeFilterCount > 0 && (
                        <span className="catalog-filter-count">{activeFilterCount}</span>
                    )}
                </button>
                {activeFilterCount > 0 && (
                    <button className="catalog-reset-btn" onClick={() => setFilters(emptyFilters)}>
                        Сбросить фильтры
                    </button>
                )}
            </div>

            <div className="catalog-grid">
                {cars && cars.length > 0 ? (
                    cars.map(car => (
                        <CarCard
                            key={car.id}
                            car={{
                                ...car,
                                displayPrice: isUsed ? car.price : car.price_base,
                                year: isUsed ? car.year_of_issue : car.year
                            }}
                            isUsed={isUsed}
                        />
                    ))
                ) : (
                    <p className="catalog-no-data">В данный момент нет доступных авто.</p>
                )}
            </div>

            {isFilterOpen && (
                <div className="catalog-filter-overlay" onClick={() => setIsFilterOpen(false)}>
                    <div className="catalog-filter-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="catalog-filter-modal-header">
                            <h2 className="catalog-filter-modal-title">Фильтровать</h2>
                            <div className="catalog-filter-close-btn" onClick={() => setIsFilterOpen(false)}>✕</div>
                        </div>

                        <div className="catalog-filter-modal-body">
                            <div className="catalog-filter-top-row">
                                <div className="catalog-filter-field">
                                    <label className="catalog-filter-label">Модель</label>
                                    <select
                                        className="catalog-filter-select"
                                        value={draftFilters.model}
                                        onChange={(e) => setDraftFilters({ ...draftFilters, model: e.target.value })}
                                    >
                                        <option value="">Любая</option>
                                    </select>
                                </div>

                                <div className="catalog-filter-field">
                                    <label className="catalog-filter-label">Цена, евро</label>
                                    <div className="catalog-filter-price-row">
                                        <input
                                            type="number"
                                            className="catalog-filter-input"
                                            placeholder="Цена от"
                                            value={draftFilters.priceFrom}
                                            onChange={(e) => setDraftFilters({ ...draftFilters, priceFrom: e.target.value })}
                                        />
                                        <input
                                            type="number"
                                            className="catalog-filter-input"
                                            placeholder="Цена до"
                                            value={draftFilters.priceTo}
                                            onChange={(e) => setDraftFilters({ ...draftFilters, priceTo: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="catalog-filter-group">
                                <div className="catalog-filter-group-title">Тип кузова</div>
                                <div className="catalog-filter-checkbox-grid catalog-filter-checkbox-grid-6">
                                    {BODY_TYPES.map((bt) => (
                                        <label key={bt} className="catalog-filter-checkbox">
                                            <input
                                                type="checkbox"
                                                checked={draftFilters.bodyTypes.includes(bt)}
                                                onChange={() => toggleDraftArrayValue('bodyTypes', bt)}
                                            />
                                            <span>{bt}</span>
                                        </label>
                                    ))}
                                </div>
                            </div>

                            <div className="catalog-filter-group">
                                <div className="catalog-filter-group-title">Тип топлива</div>
                                <div className="catalog-filter-checkbox-grid catalog-filter-checkbox-grid-4">
                                    {FUEL_TYPES.map((ft) => (
                                        <label key={ft} className="catalog-filter-checkbox">
                                            <input
                                                type="checkbox"
                                                checked={draftFilters.fuelTypes.includes(ft)}
                                                onChange={() => toggleDraftArrayValue('fuelTypes', ft)}
                                            />
                                            <span>{ft}</span>
                                        </label>
                                    ))}
                                </div>
                            </div>

                            <div className="catalog-filter-group">
                                <div className="catalog-filter-group-title">Тип привода</div>
                                <div className="catalog-filter-checkbox-grid catalog-filter-checkbox-grid-3">
                                    {DRIVE_TYPES.map((dt) => (
                                        <label key={dt} className="catalog-filter-checkbox">
                                            <input
                                                type="checkbox"
                                                checked={draftFilters.driveTypes.includes(dt)}
                                                onChange={() => toggleDraftArrayValue('driveTypes', dt)}
                                            />
                                            <span>{dt}</span>
                                        </label>
                                    ))}
                                </div>
                            </div>

                            <div className="catalog-filter-group">
                                <div className="catalog-filter-group-title">Дополнительные параметры</div>
                                <div className="catalog-filter-checkbox-grid catalog-filter-checkbox-grid-2">
                                    <label className="catalog-filter-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={draftFilters.specialOffers}
                                            onChange={(e) => setDraftFilters({ ...draftFilters, specialOffers: e.target.checked })}
                                        />
                                        <span>Спецпредложения</span>
                                    </label>
                                    <label className="catalog-filter-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={draftFilters.inStockOnly}
                                            onChange={(e) => setDraftFilters({ ...draftFilters, inStockOnly: e.target.checked })}
                                        />
                                        <span>Есть в наличии</span>
                                    </label>
                                </div>
                            </div>

                            <div className="catalog-filter-actions-row">
                                <button className="catalog-filter-apply-btn" onClick={applyFilters}>
                                    Применить
                                </button>
                                <button className="catalog-filter-reset-link" onClick={resetFilters}>
                                    Сбросить всё
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Catalog;